export * from "./component/EpicChip";
